import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';
import { emailValidator }                from '../../validators/CustomValidators';

import {SalesOfficeDropdownComponent} from '../../components/DomainData/SalesOfficeDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-employee-edit',
  templateUrl: './EmployeeEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => EmployeeEditComponent)}]
})
export class EmployeeEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    employeeForm: FormGroup;

    
    @Input() public employee: ent.Employee;

    
    @ViewChild(SalesOfficeDropdownComponent) public salesOfficeDropdown: SalesOfficeDropdownComponent;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'firstName' : '',
          'middleName' : '',
          'lastName' : '',
          'suffix' : '',
          'username' : '',
        //   'password' : '',
          'salesOffice' : '',
          'hidSalesOffice' : '',
          'personnelNumber' : '',
          'emailAddress' : '',
          'phoneNumber' : '',
          'inactive' : ''
        };
        
        this.employeeForm = fb.group(group);
        

    }


    ngOnInit(): void {

        this.employeeForm.controls.firstName.setValidators(Validators.required);
        this.employeeForm.controls.lastName.setValidators(Validators.required);
        this.employeeForm.controls.username.setValidators(Validators.required);
        
        this.employeeForm.controls.emailAddress.setValidators([emailValidator, Validators.required]);
        this.employeeForm.controls.personnelNumber.setValidators(Validators.required);

        this.employeeForm.controls.salesOffice.setValidators(dropDownValidator);
        this.employeeForm.controls.hidSalesOffice.setValidators(hiddenDropDownValueValidator);

    }

    public setPasswordValidators(){
        if (!this.employee.ID || this.employee.ID == 0){
            this.employeeForm.controls.password.setValidators(Validators.required);
        }
    }
    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        
        this.displayDialog = false;

    }

    salesOfficeChange(event: any){
        if (this.employee){
            this.employee.SalesOfficeID = event;
        }
        
    }

    salesOfficeSelected(){
        var val = true;
        var form = this.employeeForm;
        if (form.controls.salesOffice.errors && form.controls.hidSalesOffice.errors){
            if (form.controls.salesOffice.errors.invalid && form.controls.hidSalesOffice.errors.invalid){
                val = false;
            }
        }
        return val;
    }

}